import { render, staticRenderFns } from "./ConvertPointAcknowledgement.vue?vue&type=template&id=143730ce&"
import script from "./ConvertPointAcknowledgement.vue?vue&type=script&lang=js&"
export * from "./ConvertPointAcknowledgement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports